import { UseMutationResult, useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosResponse } from "axios";

interface UseResendContactEmailProps {
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

interface ResendContactEmailPayload {
  contactId: string;
  funnel_contact: {
    email: string;
  };
}

export const useResendContactEmail = ({ onSuccess, onError }: UseResendContactEmailProps = {}): UseMutationResult<AxiosResponse, unknown, ResendContactEmailPayload> => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['resendContactEmail'],
    mutationFn: async (payload: ResendContactEmailPayload) => {
      const { contactId, ...requestPayload } = payload;
      return privateAxios.put(`/funnel/contacts/${contactId}/resend_email`, requestPayload);
    },
    onSuccess,
    onError,
  });
};

export default useResendContactEmail;
